<main>
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <div class="header">
            <h1>{{"MASCHINESTATE.JOYSTICK.HEADER" | translate}}</h1>            
        </div>

        <mat-card-content>
            <div class="home-card" id="content">
                <div class="stack-wrapper bordergreen">
                    <div class="background stack" id="wrapper">
                        <div class="background borderred" id="image-container">
                            <img class="background" id="image" src="../../../../../../assets/images/joystick/Joystick_L_lowRes.png" alt="" />
                        </div>
                        <div class="background borderred" id="image-container">
                            <img class="background" id="image" src="../../../../../../assets/images/joystick/Joystick_R_lowRes.png" alt="" />
                        </div>
                    </div>
                    <div class="joystick-positions-container borderorange stack" id="wrapper">
                        <div class="joystick-positions-container borderred" id="row">
                            <div class="joystick palmgrip left borderyellow" id="palmgrip-left">
                                <!--PALMGRIP LEFT-->
                                <app-two-directions-percentage-square-grid
                                    [_x]="this.joystickDatasets[2].leftRight.value!"
                                    [_y]="this.joystickDatasets[2].forwardBackward.value!"
                                    [_dimension]="200"
                                    class="joystick-component"
                                    id="palmgrip"
                                ></app-two-directions-percentage-square-grid>
                            </div>

                            <div class="joystick borderyellow">
                                <!--JOYSTICK LEFT-->
                                <app-two-directions-percentage-square-grid
                                    [_x]="this.joystickDatasets[0].leftRight.value!"
                                    [_y]="this.joystickDatasets[0].forwardBackward.value!"
                                    [_dimension]="300"
                                    class="joystick-component"
                                    id="joystick"
                                ></app-two-directions-percentage-square-grid>
                            </div>
                        </div>
                        <div class="joystick-positions-container borderred" id="row">
                            <div class="joystick palmgrip right borderyellow" id="palmgrip-right">
                                <!--PALMGRIP RIGHT-->
                                <app-two-directions-percentage-square-grid
                                    [_x]="this.joystickDatasets[3].leftRight.value!"
                                    [_y]="this.joystickDatasets[3].forwardBackward.value!"
                                    [_dimension]="200"
                                    class="joystick-component"
                                    id="palmgrip"
                                ></app-two-directions-percentage-square-grid>
                            </div>

                            <div class="joystick borderyellow">
                                <!--JOYSTICK RIGHT-->
                                <app-two-directions-percentage-square-grid
                                    [_x]="this.joystickDatasets[1].leftRight.value!"
                                    [_y]="this.joystickDatasets[1].forwardBackward.value!"
                                    [_dimension]="300"
                                    class="joystick-component"
                                    id="joystick"
                                ></app-two-directions-percentage-square-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
